var UNHIDEABLES = ['template', 'script', 'style'];
function isHideable(node) {
    return (node.nodeType === 1 &&
        UNHIDEABLES.indexOf(node.tagName.toLowerCase()) === -1);
}
var originalValues = [];
var rootNodes = [];
export function addAriaHidden(dialogNode) {
    var elements = document.querySelectorAll('body > *');
    for (var i = 0; i < elements.length; i++) {
        var node = elements[i];
        if (!isHideable(node) || node === dialogNode.parentNode) {
            return;
        }
        var attr = node.getAttribute('aria-hidden');
        if (!attr || attr === 'false') {
            originalValues.push(attr || 'false');
            if (!rootNodes.includes(node)) {
                rootNodes.push(node);
            }
            node.setAttribute('aria-hidden', 'true');
        }
    }
}
export function removeAriaHidden() {
    rootNodes.forEach(function (node, index) {
        var originalValue = originalValues[index];
        if (originalValue === 'false') {
            node.removeAttribute('aria-hidden');
        }
        else {
            node.setAttribute('aria-hidden', originalValue);
        }
    });
}
//# sourceMappingURL=ariaHiddenHandler.js.map